import type { KeyboardEvent, SyntheticEvent } from 'react'

/**
 * Делает кликабельный не-интерактивный элемент доступным с клавиатуры.
 *
 * <p>`div` и `span` с обработчиком клика недостижимы для тех, кто работает
 * без мыши: у них нет фокуса и они не реагируют на Enter/Пробел. Хелпер
 * добавляет роль, попадание в порядок обхода и обработку тех же клавиш,
 * которые сработали бы у настоящей кнопки.
 *
 * <p>Там, где по разметке допустим `<button>`, лучше использовать его, а не это.
 */
export function clickable<E extends SyntheticEvent>(onActivate: (e: E) => void) {
  return {
    role: 'button',
    tabIndex: 0,
    onClick: onActivate,
    onKeyDown: (e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        // Пробел иначе прокрутит страницу.
        e.preventDefault()
        onActivate(e as unknown as E)
      }
    },
  } as const
}
